import { render, staticRenderFns } from "./FormTextBlockSettings.vue?vue&type=template&id=7bf2f688"
import script from "./FormTextBlockSettings.vue?vue&type=script&lang=js"
export * from "./FormTextBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports